import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';
import { getImageSpec } from '@/utils/locals';

const defaultStyle = {
    background: 'transparent',
    padding: '0',
    margin: 0,
    border: 'none',
    borderRadius: '0',
};
const webpUrl = '/media/rivermini/pc/';
const PageConPc = dynamic(() => import('@/components/productRiver/rivermini/indexDynamic'), {
    ssr: true,
});

export default function RiverMiniModule({ cssStyle }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('riverminiportablepowerstation');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu']);
    const bannerData = [
        {
            bgImgs: [`1_banner_${imgSpec}.webp`, `1_banner_${imgSpec}.jpg`],
            title: t('river_mini.title'),
            des: t('river_mini.subtitle'),
        },
    ];

    return (
        <div
            className={`${css.animationWrapper} riverMiniModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div style={{ width: '100%', marginTop: '-64px' }} className="page-river-mini-banner">
                <BannerModule data={bannerData} config={{ theme: '#000', position: 'top', webpUrl }} />
            </div>
            <PageConPc />
        </div>
    );
}
